/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZipCode2SvgDto } from '../../models/zip-code-2-svg-dto';

export interface GetSvgForZipCode$Params {
  zipCode: string;
}

export function getSvgForZipCode(http: HttpClient, rootUrl: string, params: GetSvgForZipCode$Params, context?: HttpContext): Observable<StrictHttpResponse<ZipCode2SvgDto>> {
  const rb = new RequestBuilder(rootUrl, getSvgForZipCode.PATH, 'get');
  if (params) {
    rb.path('zipCode', params.zipCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZipCode2SvgDto>;
    })
  );
}

getSvgForZipCode.PATH = '/zipCode2Svg/{zipCode}';
